import { TenantContext } from './contexts';

export const withTenant = (Component: any) => (props: any) => (
  <TenantContext.Consumer>
    {({ settings, tenant, updateTenant, currencies }) => (
      <Component
        settings={settings}
        tenant={tenant}
        updateTenant={updateTenant}
        currencies={currencies}
        {...props}
      />
    )}
  </TenantContext.Consumer>
);
